/**
 * @const defaultUserData
 * @param {string} memberid id
 * @param {string} name 會員名稱 default: 會員您好
 */
export const defaultUserData = {
  memberid: '',
  name: '會員您好',
};
